<template>
	<div>
		<div v-if="sessionExpiring" class="alert alert--danger">
			<div>
				<div>
					<p>Automatic Logout In {{ time }}</p>
				</div>
				<div>
					<process-button
						:processing="refreshing" class="button button--negative--small" text="Cancel Logout"
						@click="refresh"/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {createNamespacedHelpers} from "vuex";

const {mapState} = createNamespacedHelpers("auth");

export default {
	data() {
		return {
			refreshing: false,
		};
	},

	computed: {
		...mapState([
			"sessionExpires",
		]),
		sessionExpiring() {
			return this.sessionExpires <= 120;
		},
		time() {
			let mDuration = moment.duration(this.sessionExpires, "seconds");
			return [
				("00" + mDuration.minutes()).slice(-2),
				("00" + mDuration.seconds()).slice(-2),
			].join(":");
		},
	},

	methods: {
		refresh() {
			this.refreshing = !this.refreshing;
			this.$store.dispatch("authStore/refresh").then(() => {
				this.refreshing = !this.refreshing;
			});
		},
	},
};
</script>
